import Footer from '#/components/layout/Footer'
import Navbar from '#/components/layout/Navbar'
import FloatingWhatsApp from '#/components/common/FloatingWhatsApp'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_home')({
  component: HomeLayout,
})

function HomeLayout() {
  return (
    <div>
      <Navbar />
      <div className="min-h-dvh">
        <Outlet />
      </div>
      <Footer />
      <FloatingWhatsApp />
    </div>
  )
}
